import React, { useState } from "react";
import Modal from 'react-bootstrap/Modal';
import Pages from '.';
import { elakayAutoText } from "../../pageInside/dataElakay";


const D = {
  blue: "#3b82f6", blueLt: "#dbeafe",
  green: "#10b981", greenLt: "#f0fdf4",
  red: "#ef4444", redLt: "#fff5f5",
  purple: "#8b5cf6", purpleLt: "#ede9fe",
  txt1: "#0f172a", txt2: "#475569", txt3: "#94a3b8",
  border: "#e2e8f0", bg: "#f8fafc", bgDeep: "#f1f5f9",
  font: "'Inter','Segoe UI',system-ui,sans-serif",
  radius: 8,
  shadow: "0 1px 3px rgba(0,0,0,0.08)",
  shadowMd: "0 4px 16px rgba(0,0,0,0.07)",
};

const Toggle = ({ checked, onChange, label }) => (
  <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
    <button type="button" onClick={onChange}
      style={{
        position: "relative", width: 42, height: 24, padding: 0, border: "none",
        background: checked ? D.blue : "#cbd5e1", borderRadius: 12,
        cursor: "pointer", transition: "background .2s", flexShrink: 0,
      }}>
      <span style={{
        position: "absolute", top: 3, left: checked ? 21 : 3,
        width: 18, height: 18, background: "#fff", borderRadius: "50%",
        transition: "left .2s", display: "block",
      }} />
    </button>
    {label && <span style={{ fontSize: 12, color: D.txt3, fontWeight: 600 }}>{label}</span>}
  </div>
);

const FormPageLang0 = (props) => {
  const {
    editAddByJson = false, infoSource,
    editAdd, setEditAdd, nameObj, paragra, setParagra, ObjetPage,
    edit_add, token, AlllanguageSelect, languageUsertra, languageTradictor,
    updateLanguageElakay0, reorderLanguageElakay0, deleteLanguageElakay0, updateLanguageFileUp, buttonAddLanguage
  } = props;

  const txt = (key) => {
    const val = infoSource.laguangeElakay?.("frontElakayHardcodedText", infoSource.languageAPI)?.languageFormPageLang0?.[key];
    return typeof val === 'string' ? val : '';
  };

  const __elakayText = (key, fallback = '') => {
    const val = infoSource?.laguangeElakay?.("frontElakayHardcodedText", infoSource.languageAPI)?.formPageLang0?.[key];
    return typeof val === 'string' ? val : fallback;
  };

  const listeType = ['1', 'a', 'A', 'i', 'I', __elakayText("t002", "ul")];

  // ── helpers ────────────────────────────────────────────────────────────────

  const checkProdKeyExit = (ad) => {
    let ac = ad[0];
    let ent = Object.keys(ac ? ac : {});
    return ent.every((key) => ac[key] != undefined) && true;
  };

  const isPlainObject = (obj) => obj && typeof obj === "object" && !Array.isArray(obj);
  const linkEmptyValue = () => ({ title: '', href: '' });
  const linkToEditable = (obj) => isPlainObject(obj)
    ? { title: obj.title || '', href: obj.href || '' }
    : linkEmptyValue();
  const linkToPayload = (obj) => {
    const next = linkToEditable(obj);
    return next.title || next.href ? next : '';
  };
  const checkObjBoolean = (obj) => {
    const next = linkToEditable(obj);
    return !!(next.title || next.href);
  };
  const selHrefL = (obj) => linkToEditable(obj);
  const checkObjEmpty = (a) => JSON.stringify(a) === '{}';
  const mediaModeValue = (value) => (value === 'image' || value === 'video' ? value : '');
  const stringValue = (value) => value == null ? '' : String(value);

  const selHreflink = (obj) => {
    if (checkObjBoolean(obj.link)) return linkToEditable(obj.link);
    if (checkObjBoolean(obj.href)) return linkToEditable(obj.href);
    return linkEmptyValue();
  };

  const checkHrefLink = (a) => {
    let ent = Object.keys(a || {});
    if (ent.includes('link') && checkObjBoolean(a.link)) { setHrefLink('link'); setValue(selHrefL(a['link'])); }
    else if (ent.includes('href') && checkObjBoolean(a.href)) { setHrefLink('href'); setValue(selHrefL(a['href'])); }
    else { setHrefLink(''); setValue(objValue); }
  };

  const stringToArray = (a) => {
    if (Array.isArray(a)) return a?.length === 1 && a[0] === '' ? [] : a;
    if (typeof a === 'string' && a !== '') return a.split(/\r?\n/);
    return [];
  };

  const arrayToString = (a) => Array.isArray(a) ? a.join('\r\n') : a;

  const checkProductTrue = (c) => {
    let textfil = "";
    for (let fil in c) { textfil += c[fil] === '' && ''; }
    return textfil;
  };

  // ── state ──────────────────────────────────────────────────────────────────

  let objValue = { title: '', href: '' };

  const [error, setError] = useState('');
  const [addFille, setAddfille] = useState(false);
  const [viewPage, setViewPage] = useState(true);
  const [deletePara, setDeletePara] = useState(false);
  const [checkdeletePara, setCheckDeletePara] = useState(false);
  const [imageVideo, setImageVideo] = useState('');
  const [hreflink, setHrefLink] = useState('');
  const [stylePara, setStylePara] = useState([4, 'a']);
  const [value, setValue] = useState(selHreflink(paragra));
  const [positionDrafts, setPositionDrafts] = useState({});
  const [showLayersPanel, setShowLayersPanel] = useState(false);

  const { title, text, list, video, image } = paragra;
  const paragraphs = Array.isArray(languageTradictor?.[nameObj]) ? languageTradictor[nameObj] : [];
  const selectedParagraphId = paragra?._id ? String(paragra._id) : "";
  const selectedIndex = paragraphs.findIndex((item) => String(item?._id) === selectedParagraphId);
  const paragraphTitle = (item, index) => {
    const raw = String(item?.title || "").replace(/<[^>]*>/g, "").trim();
    return raw || elakayAutoText("h_93ef06458d793f", "Objet {value0}", { value0: index + 1 });
  };

  // ── actions ────────────────────────────────────────────────────────────────

  const selectParagraph = (next) => {
    if (!next) return;
    setStylePara(Array.isArray(next.stylePara) ? next.stylePara : [4, 'a']);
    setImageVideo(mediaModeValue(next.VORI));
    checkHrefLink(next);
    setParagra(next);
  };

  const buildParagraphPayload = () => ({
    _id: paragra._id,
    title,
    text: stringToArray(text),
    list: stringToArray(list),
    href: linkToPayload(paragra.href),
    link: linkToPayload(paragra.link),
    VORI: mediaModeValue(paragra.VORI || imageVideo),
    imagePath: stringValue(paragra.imagePath),
    videoPath: stringValue(paragra.videoPath),
    stylePara,
  });

  const buttonAdd = () => {
    updateLanguageElakay0(languageTradictor._id, token, {
      [nameObj]: buildParagraphPayload()
    }, false).then(data => {
      if (data.error) { setError(data.error); }
      else { AlllanguageSelect(); languageUsertra(); setEditAdd(true); setParagra(ObjetPage); }
    });
  };

  const buttonAddFile = () => {
    let file = 'video' == imageVideo && video.file || 'image' == imageVideo && image.file;
    updateLanguageFileUp(languageTradictor._id, paragra._id, nameObj, token, file, imageVideo).then(data => {
      if (data.error) { setError(data.error); }
      else { AlllanguageSelect(); languageUsertra(); setEditAdd(true); setParagra(ObjetPage); }
    });
  };

  const buttonDelPara = () => {
    deleteLanguageElakay0(languageTradictor._id, paragra._id, nameObj, token).then(data => {
      if (data.error) { setError(data.error); }
      else {
        AlllanguageSelect(); languageUsertra();
        setCheckDeletePara(false); setDeletePara(false);
        setEditAdd(true); setParagra(ObjetPage);
      }
    });
  };

  const handleLanguage = () => event => {
    const val = event.target.value;
    const next = languageTradictor[nameObj][val];
    selectParagraph(next);
  };

  const handleStylePara = (i, e) => {
    stylePara.splice(i, 1, e);
    setStylePara(stylePara);
    setParagra({ ...paragra });
  };

  const clickEditAdd = () => {
    setEditAdd(editAdd ? false : true);
    if (!edit_add && !checkProdKeyExit(languageTradictor[nameObj])) {
      let newParagra = languageTradictor[nameObj][0];
      setPositionDrafts({});
      if (editAdd) { selectParagraph(newParagra); }
      else if (editAddByJson) { selectParagraph(newParagra); }
      else { setAddfille(false); setImageVideo(''); setHrefLink(''); setValue(objValue); setParagra(ObjetPage); }
    } else {
      setError(editAdd ? elakayAutoText("h_932f30ae638ce2", "they is no data to edit") : "");
      setPositionDrafts({});
      setImageVideo('');
      setHrefLink('');
      setValue(objValue);
      setParagra(ObjetPage);
    }
  };

  const clickAddFile = () => setAddfille(addFille ? false : true);

  const handleChange = name => event => {
    setParagra({ ...paragra, [name]: event.target.value });
  };

  const handleFileChange = name => event => {
    const files = event.target.files;
    for (let file of files) {
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.addEventListener('load', () => {
        let fileobj = { file, name: file.name, type: file.type, size: file.size, src: reader.result };
        setParagra({ ...paragra, [name]: fileobj });
      });
    }
  };

  const handleVideoimage = (val) => {
    setImageVideo(val);
    setParagra({
      ...paragra,
      VORI: val,
      video: '',
      thumbnail: '',
      image: '',
      ...(val === 'image' ? { videoPath: '' } : {}),
      ...(val === 'video' ? { imagePath: '' } : {}),
    });
  };

  const handleHrefLink = (val) => {
    if (val == hreflink) { setHrefLink(''); setValue(objValue); }
    else { setHrefLink(val); setValue(selHrefL(paragra[val])); }
  };

  const handleChangeHrfLink = name => event => {
    const next = { ...linkToEditable(paragra[hreflink]), [name]: event.target.value };
    setValue(next);
    setParagra({ ...paragra, [hreflink]: next });
  };

  const clearHrefLink = (key) => {
    setParagra({ ...paragra, [key]: '' });
    if (hreflink === key) setValue(linkEmptyValue());
  };

  const handleMediaValue = (key) => event => {
    const nextValue = event.target.value;
    setParagra({
      ...paragra,
      [key]: nextValue,
      ...(key === 'imagePath' && nextValue ? { VORI: 'image' } : {}),
      ...(key === 'videoPath' && nextValue ? { VORI: 'video' } : {}),
    });
    if (key === 'imagePath' && nextValue) setImageVideo('image');
    if (key === 'videoPath' && nextValue) setImageVideo('video');
  };

  const handleMediaMode = event => {
    const nextMode = mediaModeValue(event.target.value);
    setImageVideo(nextMode);
    setParagra({
      ...paragra,
      VORI: nextMode,
      ...(nextMode === '' ? { imagePath: '', videoPath: '', video: '', thumbnail: '', image: '' } : {}),
      ...(nextMode === 'image' ? { videoPath: '' } : {}),
      ...(nextMode === 'video' ? { imagePath: '' } : {}),
    });
  };

  const clearMediaKeys = () => {
    setImageVideo('');
    setParagra({ ...paragra, VORI: '', imagePath: '', videoPath: '', video: '', thumbnail: '', image: '' });
  };

  const clearMediaPath = (key) => {
    const next = { ...paragra, [key]: '' };
    if (key === 'imagePath' && mediaModeValue(next.VORI) === 'image') next.VORI = '';
    if (key === 'videoPath' && mediaModeValue(next.VORI) === 'video') next.VORI = '';
    setImageVideo(mediaModeValue(next.VORI));
    setParagra(next);
  };

  const moveParagraphToPosition = (item, rawPosition) => {
    if (!item?._id || !reorderLanguageElakay0 || paragraphs.length === 0) return;
    const position = Math.max(0, Math.min(paragraphs.length - 1, Math.round(Number(rawPosition) || 0)));
    reorderLanguageElakay0(languageTradictor._id, token, nameObj, item._id, position, false).then(data => {
      if (data.error) {
        setError(data.error);
      } else {
        const nextDoc = data.frTxtLanguage || data;
        const nextList = Array.isArray(nextDoc?.[nameObj]) ? nextDoc[nameObj] : [];
        const nextItem = nextList.find((entry) => String(entry?._id) === String(item._id)) || nextList[position];
        setPositionDrafts({});
        if (nextItem) selectParagraph(nextItem);
        AlllanguageSelect();
        languageUsertra();
        setEditAdd(false);
      }
    });
  };

  const CheckInputBool = (ti, te, li) => ti !== '' && (te !== '' || li !== '');

  let paraALLBoo = checkProductTrue(paragra) || !editAdd;
  const pageView = !viewPage ? false : paraALLBoo;

  // ── shared label style ─────────────────────────────────────────────────────
  const lblSt = {
    display: "block", fontSize: 10, fontWeight: 700, color: D.txt3,
    textTransform: "uppercase", letterSpacing: 0.7, marginBottom: 5,
  };

  const inpSt = {
    width: "100%", padding: "8px 11px", boxSizing: "border-box",
    border: `1px solid ${D.border}`, borderRadius: D.radius,
    fontSize: 13, color: D.txt1, fontFamily: D.font,
    background: "#fff", outline: "none",
  };

  // ── sub-components ─────────────────────────────────────────────────────────

  const SectionDivider = ({ label }) => (
    <div style={{ display: "flex", alignItems: "center", gap: 8, margin: "14px 0 10px" }}>
      <span style={{ fontSize: 10, fontWeight: 700, color: D.txt3, textTransform: "uppercase", letterSpacing: 0.7, whiteSpace: "nowrap" }}>
        {label}
      </span>
      <div style={{ flex: 1, height: 1, background: D.border }} />
    </div>
  );

  const FormattingToolbar = () => (
    <div style={{
      display: "flex", alignItems: "center", flexWrap: "wrap", gap: 3,
      padding: "8px 10px",
      background: D.bgDeep,
      border: `1px solid ${D.border}`,
      borderRadius: D.radius,
      marginBottom: 16,
    }}>
      <span style={{ fontSize: 9, fontWeight: 700, color: D.txt3, textTransform: "uppercase", letterSpacing: 0.5, marginRight: 2 }}>
        {txt("t012") || elakayAutoText("h_a3089b7fae27bc", "Heading")}
      </span>
      {[1, 2, 3, 4, 5, 6].map(n => (
        <button key={n} type="button" onClick={() => handleStylePara(0, n)}
          title={`H${n}`}
          style={{
            width: 30, height: 26, padding: 0, borderRadius: 4,
            border: `1px solid ${stylePara[0] === n ? D.blue : "transparent"}`,
            background: stylePara[0] === n ? D.blue : "transparent",
            color: stylePara[0] === n ? "#fff" : D.txt2,
            fontWeight: 700, fontSize: 11, cursor: "pointer",
            fontFamily: D.font, transition: "all .12s",
          }}>
          H{n}
        </button>
      ))}

      <div style={{ width: 1, height: 20, background: D.border, margin: "0 6px" }} />

      <span style={{ fontSize: 9, fontWeight: 700, color: D.txt3, textTransform: "uppercase", letterSpacing: 0.5, marginRight: 2 }}>
        {txt("t014") || elakayAutoText("h_a1fffaaafb7cc9", "List")}
      </span>
      {listeType.map(t => (
        <button key={t} type="button" onClick={() => handleStylePara(1, t)}
          title={elakayAutoText("h_e413aedbe75d6f", "List: {value0}", { value0: t })}
          style={{
            minWidth: 30, height: 26, padding: "0 5px", borderRadius: 4,
            border: `1px solid ${stylePara[1] === t ? D.green : "transparent"}`,
            background: stylePara[1] === t ? D.green : "transparent",
            color: stylePara[1] === t ? "#fff" : D.txt2,
            fontWeight: stylePara[1] === t ? 700 : 400,
            fontSize: 11, cursor: "pointer", fontFamily: D.font,
            transition: "all .12s",
          }}>
          {t}
        </button>
      ))}
    </div>
  );

  const ParagraphSelector = () => (
    <div style={{ flex: 1, minWidth: 180, maxWidth: 360 }}>
      <select onChange={handleLanguage()}
        style={{ ...inpSt, cursor: "pointer", padding: "7px 10px" }}>
        <option value={0}>{txt("t001")}</option>
        {!checkObjEmpty(languageTradictor) && paragraphs?.map((ob, j) =>
          <option key={ob?._id || j} value={j}>{paragraphTitle(ob, j)}</option>
        )}
      </select>
    </div>
  );

  const ChipButton = ({ active, onClick, color = D.blue, colorLt = D.blueLt, children }) => (
    <button type="button" onClick={onClick}
      style={{
        padding: "4px 12px", borderRadius: 20,
        border: `1px solid ${active ? color : D.border}`,
        background: active ? colorLt : "#fff",
        color: active ? color : D.txt2,
        fontSize: 12, fontWeight: active ? 700 : 400,
        cursor: "pointer", fontFamily: D.font, transition: "all .12s",
      }}>
      {children}
    </button>
  );

  const LayersOrderPanel = () => {
    if (!paragraphs.length) return null;
    return (
      <div style={{
        padding: showLayersPanel ? "10px 12px" : "0",
        marginBottom: 14,
        borderRadius: D.radius,
        border: `1px solid ${D.border}`,
        background: D.bg,
        overflow: "hidden",
      }}>
        <button type="button" onClick={() => setShowLayersPanel((value) => !value)}
          style={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 10,
            padding: "10px 12px",
            border: "none",
            background: "transparent",
            cursor: "pointer",
            fontFamily: D.font,
          }}>
          <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <span style={{ fontSize: 11, color: D.txt3, transform: showLayersPanel ? "rotate(90deg)" : "rotate(0deg)", transition: "transform .15s" }}>▶</span>
            <span style={{ ...lblSt, marginBottom: 0 }}>
              {elakayAutoText("h_7e7dbb61696c0f", "Ordre / Layers")}
            </span>
          </span>
          <span style={{ fontSize: 10, color: D.txt3, whiteSpace: "nowrap" }}>
            {showLayersPanel
              ? elakayAutoText("h_65799b6214c279", "0 = premier")
              : elakayAutoText("h_7ea8fdc5e40b48", "{value0} objet(s)", { value0: paragraphs.length })}
          </span>
        </button>
        {showLayersPanel && <div style={{ display: "grid", gap: 6 }}>
          {paragraphs.map((item, index) => {
            const itemId = String(item?._id || index);
            const active = itemId === selectedParagraphId;
            const draft = positionDrafts[itemId] ?? index;
            return (
              <div key={itemId}
                style={{
                  display: "grid",
                  gridTemplateColumns: "34px minmax(0,1fr) 72px auto auto auto",
                  gap: 6,
                  alignItems: "center",
                  padding: "6px 7px",
                  borderRadius: 6,
                  border: `1px solid ${active ? D.blue : D.border}`,
                  background: active ? "#eff6ff" : "#fff",
                }}>
                <button type="button" onClick={() => selectParagraph(item)}
                  title={elakayAutoText("h_2657f9c4f6a83c", "Modifier cet objet")}
                  style={{
                    width: 28,
                    height: 28,
                    borderRadius: 6,
                    border: "none",
                    background: active ? D.blue : D.bgDeep,
                    color: active ? "#fff" : D.txt2,
                    fontSize: 12,
                    fontWeight: 700,
                    cursor: "pointer",
                    fontFamily: D.font,
                  }}>
                  {index}
                </button>
                <button type="button" onClick={() => selectParagraph(item)}
                  title={paragraphTitle(item, index)}
                  style={{
                    minWidth: 0,
                    padding: 0,
                    border: "none",
                    background: "transparent",
                    color: active ? D.blue : D.txt1,
                    fontSize: 12,
                    fontWeight: active ? 700 : 600,
                    textAlign: "left",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    cursor: "pointer",
                    fontFamily: D.font,
                  }}>
                  {paragraphTitle(item, index)}
                </button>
                <input
                  type="number"
                  min={0}
                  max={Math.max(0, paragraphs.length - 1)}
                  value={draft}
                  onChange={(event) => setPositionDrafts({ ...positionDrafts, [itemId]: event.target.value })}
                  onKeyDown={(event) => {
                    if (event.key === "Enter") moveParagraphToPosition(item, event.currentTarget.value);
                  }}
                  title={elakayAutoText("h_bf115aa4fb4165", "Position")}
                  style={{
                    width: "100%",
                    padding: "6px 7px",
                    border: `1px solid ${D.border}`,
                    borderRadius: 6,
                    fontSize: 12,
                    color: D.txt1,
                    background: "#fff",
                    outline: "none",
                    fontFamily: D.font,
                    boxSizing: "border-box",
                  }}
                />
                <button type="button" onClick={() => moveParagraphToPosition(item, draft)}
                  style={{ padding: "6px 8px", borderRadius: 6, border: `1px solid ${D.border}`, background: "#fff", color: D.blue, fontSize: 11, fontWeight: 700, cursor: "pointer", fontFamily: D.font }}>
                  {elakayAutoText("h_0fc35929807069", "OK")}
                </button>
                <button type="button" disabled={index === 0} onClick={() => moveParagraphToPosition(item, index - 1)}
                  title={elakayAutoText("h_0cc4a82c164b1d", "Monter")}
                  style={{ width: 28, height: 28, borderRadius: 6, border: `1px solid ${D.border}`, background: index === 0 ? D.bgDeep : "#fff", color: index === 0 ? D.txt3 : D.txt2, cursor: index === 0 ? "not-allowed" : "pointer", fontFamily: D.font }}>
                  ↑
                </button>
                <button type="button" disabled={index === paragraphs.length - 1} onClick={() => moveParagraphToPosition(item, index + 1)}
                  title={elakayAutoText("h_7deba139113e30", "Bas")}
                  style={{ width: 28, height: 28, borderRadius: 6, border: `1px solid ${D.border}`, background: index === paragraphs.length - 1 ? D.bgDeep : "#fff", color: index === paragraphs.length - 1 ? D.txt3 : D.txt2, cursor: index === paragraphs.length - 1 ? "not-allowed" : "pointer", fontFamily: D.font }}>
                  ↓
                </button>
              </div>
            );
          })}
        </div>}
        {showLayersPanel && selectedIndex >= 0 && (
          <p style={{ margin: "8px 0 0", fontSize: 10, color: D.txt3, lineHeight: 1.5 }}>
            {elakayAutoText("h_774e6a12ea3a4d", "Objet sélectionné à la position {value0}.", { value0: selectedIndex })}
          </p>
        )}
      </div>
    );
  };

  const deleteAgree = () => (
    <Modal show={deletePara} onHide={() => setDeletePara(false)}
      dialogClassName="modal-90w" aria-labelledby="del-modal-lang0" centered>
      <Modal.Header closeButton>
        <Modal.Title id="del-modal-lang0">
          <span style={{ fontSize: 16, fontWeight: 700, fontFamily: D.font }}>
            {infoSource.language(infoSource, "title", "delThtems")}
          </span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={{ padding: "8px 4px" }}>
          <Pages stylePara={stylePara} classAlert="alert alert-success"
            paragra={paragra} imageVideo={imageVideo} paraALLBoo={pageView}
            preview infoSource={infoSource} />

          <div style={{
            display: "flex", alignItems: "flex-start", gap: 10, marginTop: 16,
            padding: "12px 14px", background: D.redLt, borderRadius: D.radius,
            border: "1px solid #fca5a5",
          }}>
            <input
              onChange={() => setCheckDeletePara(!checkdeletePara)}
              type="checkbox" checked={checkdeletePara}
              id="chButAgreeLang0"
              style={{ width: 16, height: 16, marginTop: 2, cursor: "pointer", accentColor: D.red }} />
            <label htmlFor="chButAgreeLang0"
              style={{ fontSize: 13, color: "#991b1b", cursor: "pointer", fontFamily: D.font }}>
              {infoSource.language(infoSource, "title", "chButAgree")}
            </label>
          </div>

          <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 14 }}>
            {viewPage && paragra._id != undefined && checkdeletePara
              ? <button onClick={buttonDelPara}
                  style={{ padding: "8px 20px", borderRadius: D.radius, border: "none", background: D.red, color: "#fff", fontSize: 13, fontWeight: 600, cursor: "pointer", fontFamily: D.font }}>
                  {txt("t008")}
                </button>
              : <button disabled
                  style={{ padding: "8px 20px", borderRadius: D.radius, border: "none", background: "#f1f5f9", color: D.txt3, fontSize: 13, fontWeight: 600, cursor: "not-allowed", fontFamily: D.font }}>
                  {txt("t009")}
                </button>
            }
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );

  // ── main editor ────────────────────────────────────────────────────────────

  const EditorPane = () => (
    <div style={{
      flex: "0 0 56%", minWidth: 0, padding: "18px 20px",
      borderRight: `1px solid ${D.border}`,
      overflowY: "auto", maxHeight: "80vh",
    }}>
      <FormattingToolbar />

      {error && (
        <div style={{
          display: "flex", alignItems: "center", gap: 8, padding: "8px 12px",
          background: D.redLt, borderRadius: 6, border: "1px solid #fca5a5", marginBottom: 12,
        }}>
          <span style={{ fontSize: 14 }}>⚠</span>
          <span style={{ fontSize: 12, color: "#991b1b" }}>{error}</span>
        </div>
      )}

      {!addFille && !editAdd && <LayersOrderPanel />}

      {!addFille && (
        <>
          {/* Title */}
          <SectionDivider label={txt("t012") || elakayAutoText("h_768e0c1c69573f", "Title")} />
          <input onChange={handleChange('title')} type="text" value={title}
            placeholder={__elakayText("t004", "enter your the title")}
            style={{ ...inpSt, fontSize: 15, fontWeight: 500, marginBottom: 4 }} />

          {/* Body text */}
          <SectionDivider label={txt("t013") || elakayAutoText("h_9682ce107c0cee", "Body Text")} />
          <textarea onChange={handleChange('text')} value={arrayToString(text)} rows={7}
            placeholder={__elakayText("t005", "enter your the text")}
            style={{
              ...inpSt, resize: "vertical", lineHeight: 1.7,
              fontFamily: "inherit", marginBottom: 4,
            }} />

          {/* List */}
          <SectionDivider label={txt("t014") || elakayAutoText("h_a1fffaaafb7cc9", "List")} />
          <textarea onChange={handleChange('list')} value={arrayToString(list)} rows={4}
            placeholder={__elakayText("t006", "enter your the liste")}
            style={{
              ...inpSt, resize: "vertical", lineHeight: 1.7,
              fontFamily: "inherit", marginBottom: 4,
            }} />

          {/* Links */}
          <SectionDivider label={elakayAutoText("h_014bcd654c60d5", "Links")} />
          <div style={{ display: "flex", gap: 8, marginBottom: 10 }}>
            <ChipButton active={hreflink === 'href'} onClick={() => handleHrefLink('href')}>
              {txt("t006") || elakayAutoText("h_7a0ca1c963f5aa", "href")}
            </ChipButton>
            <ChipButton active={hreflink === 'link'} onClick={() => handleHrefLink('link')}>
              {txt("t007") || elakayAutoText("h_4f0aa52d656a3d", "link")}
            </ChipButton>
          </div>
          {hreflink && (
            <div style={{ marginBottom: 4 }}>
              <div style={{ marginBottom: 8 }}>
                <label style={lblSt}>{__elakayText("t001", "Title of")} {hreflink}</label>
                <input onChange={handleChangeHrfLink('title')} type="text" value={value.title}
                  placeholder={elakayAutoText("h_2c9aaa4ac0f4e8", "title for {value0}", { value0: hreflink })} style={inpSt} />
              </div>
              <div>
                <label style={lblSt}>{hreflink}{elakayAutoText("h_0e2d9b0777a485", "URL")}</label>
                <input onChange={handleChangeHrfLink('href')} type="text" value={value.href}
                  placeholder={elakayAutoText("h_3d576392b21828", "URL for {value0}", { value0: hreflink })} style={inpSt} />
              </div>
              <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 8 }}>
                <button type="button" onClick={() => clearHrefLink(hreflink)}
                  style={{ padding: "5px 10px", borderRadius: D.radius, border: `1px solid ${D.border}`, background: "#fff", color: D.red, fontSize: 11, fontWeight: 700, cursor: "pointer", fontFamily: D.font }}>
                  {elakayAutoText("h_70e9ec9d3db0c4", "Supprimer")} {hreflink}
                </button>
              </div>
            </div>
          )}

          {/* Technical keys */}
          <SectionDivider label={elakayAutoText("h_4d19f44a35fc26", "Champs techniques")} />
          <div style={{ display: "grid", gridTemplateColumns: "150px 1fr", gap: 8, alignItems: "end", marginBottom: 8 }}>
            <label style={{ display: "block" }}>
              <span style={lblSt}>{elakayAutoText("h_6cad842f1fa4b3", "VORI")}</span>
              <select value={mediaModeValue(paragra.VORI || imageVideo)} onChange={handleMediaMode}
                style={{ ...inpSt, cursor: "pointer" }}>
                <option value="">{elakayAutoText("h_65d1e7b8203a45", "Aucun")}</option>
                <option value="image">{elakayAutoText("h_50e19fda0d5b4b", "Image")}</option>
                <option value="video">{elakayAutoText("h_bc17c1f0179a88", "Video")}</option>
              </select>
            </label>
            <div style={{ display: "flex", justifyContent: "flex-end", paddingBottom: 1 }}>
              <button type="button" onClick={clearMediaKeys}
                style={{ padding: "7px 12px", borderRadius: D.radius, border: `1px solid ${D.border}`, background: "#fff", color: D.red, fontSize: 11, fontWeight: 700, cursor: "pointer", fontFamily: D.font }}>
                {elakayAutoText("h_0857d592013ab5", "Réinitialiser média")}
              </button>
            </div>
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr auto", gap: 8, alignItems: "end", marginBottom: 8 }}>
            <label style={{ display: "block" }}>
              <span style={lblSt}>{elakayAutoText("h_0f027b736e7b49", "imagePath")}</span>
              <input onChange={handleMediaValue('imagePath')} type="text" value={stringValue(paragra.imagePath)}
                placeholder={elakayAutoText("h_1f5209036e9d77", "URL ou chemin image")} style={inpSt} />
            </label>
            <button type="button" onClick={() => clearMediaPath('imagePath')}
              style={{ padding: "8px 11px", borderRadius: D.radius, border: `1px solid ${D.border}`, background: "#fff", color: D.red, fontSize: 11, fontWeight: 700, cursor: "pointer", fontFamily: D.font }}>
              {elakayAutoText("h_70e9ec9d3db0c4", "Supprimer")}
            </button>
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr auto", gap: 8, alignItems: "end", marginBottom: 4 }}>
            <label style={{ display: "block" }}>
              <span style={lblSt}>{elakayAutoText("h_eb1f63e5bc9ea9", "videoPath")}</span>
              <input onChange={handleMediaValue('videoPath')} type="text" value={stringValue(paragra.videoPath)}
                placeholder={elakayAutoText("h_4a82ba55f1aca3", "URL ou chemin video")} style={inpSt} />
            </label>
            <button type="button" onClick={() => clearMediaPath('videoPath')}
              style={{ padding: "8px 11px", borderRadius: D.radius, border: `1px solid ${D.border}`, background: "#fff", color: D.red, fontSize: 11, fontWeight: 700, cursor: "pointer", fontFamily: D.font }}>
              {elakayAutoText("h_70e9ec9d3db0c4", "Supprimer")}
            </button>
          </div>
          <p style={{ fontSize: 10, color: D.txt3, margin: "4px 0 0", lineHeight: 1.5 }}>
            {elakayAutoText("h_06d5ac31a11c91", "Pour supprimer une clé, laissez-la vide ou utilisez Supprimer. Le save envoie la valeur vide.")}
          </p>
        </>
      )}

      {/* Media section */}
      <SectionDivider label={txt("t003") || elakayAutoText("h_0c77aeece8c258", "Media")} />
      {!editAdd && (
        <div style={{ marginBottom: 10 }}>
          <Toggle checked={addFille} onChange={clickAddFile} label={txt("t003")} />
        </div>
      )}
      {addFille && (
        <div style={{
          background: D.bg, borderRadius: D.radius, padding: "12px 14px",
          border: `1px solid ${D.border}`, marginBottom: 14,
        }}>
          <div style={{ display: "flex", gap: 8, marginBottom: 12 }}>
            <ChipButton active={imageVideo === 'video'} onClick={() => handleVideoimage('video')}>
              {txt("t004") || elakayAutoText("h_bc17c1f0179a88", "Video")}
            </ChipButton>
            <ChipButton active={imageVideo === 'image'} onClick={() => handleVideoimage('image')}>
              {txt("t005") || elakayAutoText("h_50e19fda0d5b4b", "Image")}
            </ChipButton>
          </div>

          {imageVideo === 'video' && (
            <>
              <div style={{ marginBottom: 10 }}>
                <label style={lblSt}>{txt("t015") || elakayAutoText("h_61ca215bda7796", "Video file")}</label>
                <input onChange={handleFileChange('video')} type="file"
                  accept="video/mp4,video/*" name="video"
                  style={{ fontSize: 13, color: D.txt2, fontFamily: D.font }} />
              </div>
              {/* The thumbnail picker was removed (UP-14): buttonAddFile only ever
                  sent the video or the image, the server has no thumbnail
                  field, so the selected file was silently dropped. */}
            </>
          )}
          {imageVideo === 'image' && (
            <div>
              <label style={lblSt}>{txt("t017") || elakayAutoText("h_2fd90764d79c65", "Image file")}</label>
              <input onChange={handleFileChange('image')} type="file"
                name="image" accept="image/*"
                style={{ fontSize: 13, color: D.txt2, fontFamily: D.font }} />
            </div>
          )}
        </div>
      )}

      {/* Save action */}
      <div style={{
        display: "flex", justifyContent: "flex-end", marginTop: 16,
        paddingTop: 14, borderTop: `1px solid ${D.border}`,
      }}>
        {addFille
          ? buttonAddLanguage(buttonAddFile,
              (!checkObjEmpty(languageTradictor) && image && image.name !== '') || (video && video.name !== ''))
          : buttonAddLanguage(buttonAdd, CheckInputBool(title, text, list))
        }
      </div>
    </div>
  );

  const PreviewPane = () => (
    <div style={{
      flex: "0 0 44%", minWidth: 0, padding: "18px 18px",
      background: D.bg, overflowY: "auto", maxHeight: "80vh",
    }}>
      <span style={{
        display: "block", fontSize: 10, fontWeight: 700, color: D.txt3,
        textTransform: "uppercase", letterSpacing: 0.7,
        marginBottom: 14, paddingBottom: 10, borderBottom: `1px solid ${D.border}`,
      }}>
        {txt("t010") || elakayAutoText("h_a62da9010119c1", "Live Preview")}
      </span>

      <div style={{
        background: "#fff", borderRadius: D.radius,
        border: `1px solid ${D.border}`,
        padding: "20px 22px", minHeight: 380,
        boxShadow: D.shadow,
      }}>
        <Pages
          preview
          stylePara={stylePara}
          classAlert=""
          paragra={paragra}
          imageVideo={imageVideo}
          paragra0={languageTradictor[nameObj]}
          paraALLBoo={pageView}
          infoSource={infoSource}
        />
      </div>
    </div>
  );

  // ── render ─────────────────────────────────────────────────────────────────

  return (
    <>
      <div style={{
        border: `1px solid ${D.border}`,
        borderRadius: 10,
        overflow: "hidden",
        background: "#fff",
        boxShadow: D.shadowMd,
      }}>
        {/* ── TOP BAR ──────────────────────────────────────────────────── */}
        <div style={{
          display: "flex", alignItems: "center", flexWrap: "wrap", gap: 10,
          padding: "10px 16px",
          background: D.bgDeep,
          borderBottom: `1px solid ${D.border}`,
        }}>
          {!editAdd && <ParagraphSelector />}
          <div style={{ flex: 1 }} />
          <button type="button" onClick={() => setViewPage(!viewPage)}
            style={{
              padding: "5px 12px", borderRadius: D.radius,
              border: `1px solid ${D.border}`, background: "#fff",
              color: D.txt2, fontSize: 12, fontWeight: 600,
              cursor: "pointer", fontFamily: D.font,
            }}>
            {!viewPage
              ? infoSource.laguangeElakay('title', infoSource.languageAPI).viewInput
              : infoSource.laguangeElakay('title', infoSource.languageAPI).viewPage}
          </button>
          {paragra._id !== undefined && (
            <button type="button" onClick={() => setDeletePara(true)}
              style={{
                padding: "6px 14px", borderRadius: D.radius,
                border: "1px solid #fca5a5", background: D.redLt, color: D.red,
                fontSize: 12, fontWeight: 600, cursor: "pointer", fontFamily: D.font,
              }}>
              {txt("t011") || elakayAutoText("h_f6fdbe48dc54dd", "Delete")}
            </button>
          )}
          <Toggle checked={editAdd} onChange={clickEditAdd} label={txt("t002")} />
        </div>

        {/* ── SPLIT LAYOUT: EDITOR | PREVIEW ───────────────────────────── */}
        <div>
          <PreviewPane />
           <EditorPane />
        </div>
      </div>

      {deleteAgree()}
    </>
  );
};

export default FormPageLang0;
